export const UsersView = (props: any) => {

    return (
        <div className="w-full md:w-8/12 mx-auto p-4">
            <div className="w-12">
                <h1 className="text-2xl">Users</h1>
            </div>
        </div>
    )
}